export const getStyles = (hasOnlyOneCountry) => ({
    ".phone-input-group": Object.assign({}, (hasOnlyOneCountry
        ? {
            ".pluxee-select__control--is-disabled": {
                borderColor: "semantic.border.secondary !important",
            },
            ".pluxee-select--is-disabled": {
                borderRight: "none",
            },
        }
        : {})),
});
//# sourceMappingURL=PhoneInput.style.js.map